// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DTAStatus = {
    Draft: 'DRAFT',
    UnderReview: 'UNDER_REVIEW',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;
export type DTAStatus = typeof DTAStatus[keyof typeof DTAStatus];


export function instanceOfDTAStatus(value: any): boolean {
    for (const key in DTAStatus) {
        if (Object.prototype.hasOwnProperty.call(DTAStatus, key)) {
            if (DTAStatus[key as keyof typeof DTAStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DTAStatusFromJSON(json: any): DTAStatus {
    return DTAStatusFromJSONTyped(json, false);
}

export function DTAStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTAStatus {
    return json as DTAStatus;
}

export function DTAStatusToJSON(value?: DTAStatus | null): any {
    return value as any;
}

export function DTAStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): DTAStatus {
    return value as DTAStatus;
}
